export default () => {
    const ads = document.querySelectorAll(`.js-ad`);

    if (!ads.length) {
        return;
    }

    // enqueued async in Assets.php
    // https://www.googletagservices.com/tag/js/gpt.js
    // https://securepubads.g.doubleclick.net/tag/js/gpt.js

    window.googletag = window.googletag || { cmd: [] };

    const googletag = window.googletag || {};
    googletag.cmd = googletag.cmd || [];

    const url = window.location.pathname.slice(-40);

    ads.forEach((ad, adIndex) => {
        const lastAd = adIndex === ads.length - 1;
        const id = ad?.dataset?.id;
        const path = ad?.dataset?.path;
        const sizes = ad?.dataset?.sizes;
        const collapsedByDefault =
            (ad?.dataset?.collapse || ad?.dataset?.collapse === 'true') ??
            false;
        const expandIfFilled = true;

        if (!id && !path && !sizes && !googletag) {
            return;
        }

        googletag.cmd.push(() => {
            const pubads = googletag.pubads();

            googletag
                .defineSlot(path, JSON.parse(sizes), id)
                .addService(pubads);

            pubads.collapseEmptyDivs(collapsedByDefault, expandIfFilled);

            pubads.setTargeting('url', url);

            // pageTargeting gets inserted by php in postypes/controller
            if (typeof pageTargeting != 'undefined' && pageTargeting) {
                for (const key in pageTargeting) {
                    const value = pageTargeting[key];
                    pubads.setTargeting(key, value);
                }
            }

            pubads.addEventListener('slotRenderEnded', (event) => {
                const isEmpty = event.isEmpty;
                const slotId = event.slot.getSlotElementId();

                if (slotId === id) {
                    setAdVisibility(ad, isEmpty);

                    // only set ad-group heights when last ad has been rendered
                    if (lastAd) {
                        setAdGroupHeight();
                    }
                }
            });

            pubads.enableSingleRequest();
            googletag.enableServices();
            googletag.display(id);
        });
    });
};

const setAdVisibility = (ad, isEmpty) => {
    ad.setAttribute('data-empty', isEmpty);

    const blockAd = ad.closest(`.bf-block-ad`);
    if (blockAd) {
        blockAd.setAttribute('data-empty', isEmpty);
    }

    const labeledGroup = ad.closest(`.js-labeled-group`);
    if (labeledGroup) {
        labeledGroup.setAttribute('data-empty', isEmpty);
    }

    const headerDisplayAd = ad.closest(`.js-site-header-display-ad`);
    if (headerDisplayAd) {
        headerDisplayAd.setAttribute('data-empty', isEmpty);
    }
};

const setAdGroupHeight = () => {
    const adGroup = document.querySelector(`.js-ad-group.is-sticky`);
    if (adGroup) {
        const ads = adGroup.querySelectorAll(`[data-empty="false"]`);

        if (ads.length > 0) {
            const height =
                parseInt(adGroup.offsetHeight) / parseInt(ads.length);

            ads.forEach((ad) => {
                ad.style.minHeight = `${height}px`;
            });
        }
    }
};
